import { render } from "./charts.vue?vue&type=template&id=b06620c2&scoped=true"
import script from "./charts.vue?vue&type=script&lang=js"
export * from "./charts.vue?vue&type=script&lang=js"

import "./charts.vue?vue&type=style&index=0&id=b06620c2&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b06620c2"]])

export default __exports__